import { makeStyles } from "@material-ui/styles";

const streamStyles = makeStyles((theme) => {
	return {
		paper: {
			backgroundColor: theme.palette.menu.backgroundColor,
			border: "1px solid rgba(255,255,255,0.1)",
			display: "flex",
			flexDirection: "column",
			padding: 8,
			paddingTop: "inherit"
		},
		streamHeaderPaper: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",
			userSelect: "none",
			cursor: "grab",
			color: "white",
			width: "100%",
			height: 50
		},
		streamHeaderTitleBox: {
			display: "flex",
			alignItems: "center",
			width: "100%",
			gap: 5,
			minHeight: 48
		},
		paperHeaderButtonGroup: {
			display: "flex",
			alignItems: "center"
		},
		popper: {
			zIndex: Number.MAX_SAFE_INTEGER,
			overflow: "none"
		},
		popperHidden: {
			opacity: 0
		},
		streamVideoContainer: {
			display: "flex",
			width: "100%",
			height: "100%",
			justifyContent: "center",
			alignItems: "center",
			flexDirection: "column",
			backgroundColor: "black",
			borderRadius: 5,
			"& picture": {
				opacity: 0
			}
		},
		streamVideoContainerYt: {
			"& .vjs-big-play-button": {
				opacity: 0
			}
		},
		streamVideo: {
			width: "100%",
			height: "100%"
		},
		resizable: {
			"& .react-resizable-handle": {
				backgroundImage: "unset",
				borderBottom: "2px solid white",
				borderRight: "2px solid white",
				borderRadius: 2
			}
		},
		streamMkrContainer: {
			width: "100%",
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			"& .MuiSlider-thumb": { color: "transparent" },
			"& .MuiSlider-mark": {
				height: 7,
				backgroundColor: theme.palette.secondary.main
			}
		},
		sliderMarkActive: {
			backgroundColor: `${theme.palette.primary.main} !important`
		},
		streamMkrPreviewContainer: {
			maxWidth: "320px",
			height: "fit-content",
			backgroundColor: theme.palette.menu.backgroundColor,
			border: "1px solid rgba(255,255,255,0.1)",
			overflow: "auto",
			position: "absolute",
			bottom: 105,
			zIndex: Number.MAX_SAFE_INTEGER
		},
		streamMkrPreviewPaper: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexDirection: "column",
			padding: "10px",
			margin: "10px",
			gap: 5
		},
		streamMkrPreviewTimestamp: {
			fontWeight: "bold"
		},
		streamMkrPreviewDescription: { wordBreak: "break-all" },
		streamMkrControlsContainer: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			width: "100%",
			backgroundColor: theme.palette.menu.item.active.backgroundColor,
			borderRadius: 5
		},
		streamMkrPreviewBtnContainer: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center"
		},
		streamMkrCreateContainer: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			flexDirection: "column",
			width: "fit-content",
			height: "fit-content",
			backgroundColor: theme.palette.menu.backgroundColor,
			border: "1px solid rgba(255,255,255,0.1)",
			overflow: "hidden",
			position: "absolute",
			bottom: 50,
			zIndex: Number.MAX_SAFE_INTEGER
		},
		streamMkrCreateBtnContainer: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			gap: 5
		},
		streamMkrCreatePaper: {
			padding: "10px",
			margin: "10px",
			display: "flex",
			flexDirection: "column",
			gap: 8,
			width: "300px"
		},
		streamMkrCreatePlaysPopper: {
			zIndex: Number.MAX_SAFE_INTEGER
		},
		streamMkrCreateHiddenInput: {
			"& input": { display: "none" }
		},
		streamMkrNavigationText: {
			userSelect: "none"
		},
		streamMkrNavigationContainer: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: 10
		},
		streamPopoutBox: {
			position: "relative",
			margin: "auto",
			marginTop: "-50px",
			[theme.breakpoints.only("xs")]: {
				marginTop: 0
			},
			[theme.breakpoints.only("sm")]: {
				width: "calc(100% - 100px)"
			},
			[theme.breakpoints.only("md")]: {
				width: "calc(100% - 200px)"
			},
			[theme.breakpoints.up("lg")]: {
				width: "calc(100% - 400px)"
			}
		},
		streamMkrFbOptionContainer: {
			display: "flex",
			alignItems: "center",
			flexDirection: "row"
		},
		streamMkrPlaySelectorListBox: {
			"& .MuiAutocomplete-listbox": { padding: 0 }
		},
		streamMkrPlaySelectorReducedItems: {
			"& .MuiAutocomplete-listbox": { overflow: "hidden !important" }
		},
		streamMkrFbOptionTitle: {
			textWrap: "nowrap"
		},
		streamMkrPlaySelectorListbox: {
			height: 100,
			overflowX: "hidden",
			overflowY: "auto"
		}
	};
});

export default streamStyles;
